import { Root as SeparatorPrimitiveRoot } from '@radix-ui/react-separator'
import type { ComponentProps } from 'react'
import { cn } from '@/helpers/utils'

function Separator({
	className,
	orientation = 'horizontal',
	decorative = true,
	...props
}: ComponentProps<typeof SeparatorPrimitiveRoot>) {
	return (
		<SeparatorPrimitiveRoot
			className={cn(
				'shrink-0 bg-neutral-200',
				orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
				className
			)}
			data-slot='separator'
			decorative={decorative}
			orientation={orientation}
			{...props}
		/>
	)
}

export { Separator }
